import { Cookies } from 'react-cookie';
import {
    ROAD_BOOK_CONFIGURATION_DELETED,
    ROAD_BOOK_CONFIGURATION_DELETING,
    ROAD_BOOK_CONFIGURATION_DOWNLOADED,
    ROAD_BOOK_CONFIGURATION_FOCUS,
    ROAD_BOOK_CONFIGURATION_SENDING,
    ROAD_BOOK_CONFIGURATIONS_DOWNLOADED,
    ROAD_BOOK_CONFIGURATIONS_FAILED,
    ROAD_BOOK_CONFIGURATIONS_PENDING,
} from './types';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';

const cookies = new Cookies();

export const roadBookConfigurationsPendingAction = () => {
    return { type: ROAD_BOOK_CONFIGURATIONS_PENDING };
};

export const roadBookConfigurationsDeletingAction = () => {
    return { type: ROAD_BOOK_CONFIGURATION_DELETING };
};

export const roadBookConfigurationSendingAction = () => {
    return { type: ROAD_BOOK_CONFIGURATION_SENDING };
};

export const roadBookConfigurationFocusAction = (roadBookConfiguration) => {
    return {
        type: ROAD_BOOK_CONFIGURATION_FOCUS,
        payload: { roadBookConfiguration: roadBookConfiguration },
    };
};

export const roadBookConfigurationsDeletedAction = (roadBookConfiguration, lang) => {
    return {
        type: ROAD_BOOK_CONFIGURATION_DELETED,
        payload: { roadBookConfiguration: roadBookConfiguration, lang: lang },
    };
};

export const roadBookConfigurationsDownloadedAction = (roadBookConfigurations, lang, roadBookConfigurationId = null) => {
    return {
        type: ROAD_BOOK_CONFIGURATIONS_DOWNLOADED,
        payload: {
            roadBookConfigurations: roadBookConfigurations,
            lang: lang,
            roadBookConfigurationId: roadBookConfigurationId
        },
    };
};

export const roadBookConfigurationDownloadedAction = (roadBookConfiguration, lang) => {
    return {
        type: ROAD_BOOK_CONFIGURATION_DOWNLOADED,
        payload: {
            roadBookConfiguration: roadBookConfiguration,
            lang: lang,
        },
    };
};

export const roadBookConfigurationsFailedAction = (error) => {
    return {
        type: ROAD_BOOK_CONFIGURATIONS_FAILED,
        payload: error,
    };
};

export function fetchRoadBookConfiguration(appId, roadBookConfigurationId, lang, withDisabled) {
    return function (dispatch, getState) {
        let roadBookConfigurations = null;
        if (
            getState().roadBookConfigurations.content
            && getState().roadBookConfigurations.content.length > 0
        ) {
            roadBookConfigurations = getState().roadBookConfigurations.content[lang];
        }
        if (roadBookConfigurations !== null) {
            const roadBookConfiguration = roadBookConfigurations.find(function (rba) {
                return rba.id === roadBookConfigurationId;
            });
            if (roadBookConfiguration) {
                return dispatch(roadBookConfigurationFocusAction(roadBookConfiguration));
            }
        } else {
            return dispatch(getRoadBookConfigurations(appId, lang, withDisabled, roadBookConfigurationId));
        }
    };
}

export function getRoadBookConfigurations(appId, lang, withDisabled, roadBookConfigurationId = null) {
    return function (dispatch) {
        dispatch(roadBookConfigurationsPendingAction());
        return APIService.getRoadBookConfigurations(appId, withDisabled, cookies.get('token'), lang)
            .then(data => {
                dispatch(roadBookConfigurationsDownloadedAction(data, lang, roadBookConfigurationId));
                return data;
            }).catch((error) => {
                dispatch(handleError(error, ROAD_BOOK_CONFIGURATIONS_FAILED));
            });
    };
}

export function postRoadBookConfigurations(appId, roadBookConfiguration, lang) {
    return function (dispatch) {
        dispatch(roadBookConfigurationSendingAction());
        return APIService.postRoadBookConfiguration(appId,
            roadBookConfiguration,
            cookies.get('token'),
            lang,
        )
            .then(data => {
                dispatch(roadBookConfigurationDownloadedAction(data, lang));
                return data;
            }).catch((error) => {
                dispatch(handleError(error, ROAD_BOOK_CONFIGURATIONS_FAILED));
            });
    };
}

export function putRoadBookConfigurations(appId, roadBookConfiguration, lang) {
    return function (dispatch) {
        dispatch(roadBookConfigurationSendingAction());
        return APIService.putRoadBookConfiguration(appId,
            roadBookConfiguration,
            cookies.get('token'),
            lang,
        )
            .then(data => {
                dispatch(roadBookConfigurationDownloadedAction(data, lang));
                return data;
            }).catch((error) => {
                dispatch(handleError(error, ROAD_BOOK_CONFIGURATIONS_FAILED));
            });
    };
}

export function deleteRoadBookConfigurations(appId, roadBookConfiguration, lang) {
    return function (dispatch) {
        dispatch(roadBookConfigurationsDeletingAction());
        return APIService.deleteRoadBookConfiguration(
            appId,
            roadBookConfiguration,
            cookies.get('token'),
            lang
        )
            .then((data) => {
                if (data !== null) {
                    dispatch(roadBookConfigurationDownloadedAction(data, lang));
                } else {
                    dispatch(roadBookConfigurationsDeletedAction(roadBookConfiguration, lang));
                }
            }).catch((error) => {
                dispatch(handleError(error, ROAD_BOOK_CONFIGURATIONS_FAILED));
            });
    }
}



// WEBPACK FOOTER //
// src/store/roadBookConfigurations/actions.js